export const grossCommonDevisor = (a: number, b: number): number => (b == 0 ? a : grossCommonDevisor(b, a % b))

export const getHeightRatio = (width: number, height: number) => {
  const ratio = grossCommonDevisor(width, height)
  return height / ratio
}

export const getWidthRatio = (width: number, height: number) => {
  const ratio = grossCommonDevisor(width, height)
  return width / ratio
}

export const getResizeMultiplier = (width: number, height: number, max: number) => {
  const wRatio = getWidthRatio(width, height)
  const hRatio = getHeightRatio(width, height)
  if (wRatio > hRatio) {
    return max / width
  } else {
    return max / height
  }
}

export const scaleImageHeight = (width: number, height: number, max: number) =>
  height * getResizeMultiplier(width, height, max)

export const scaleImageWidth = (width: number, height: number, max: number) =>
  width * getResizeMultiplier(width, height, max)

// Takes an image and returns a max scaled version of it based on a length
// i.e. biggest size possible while keeping the aspect ratio
export const getMaximumImageSizeByLength = (
  image: { width: number; height: number },
  maxLength: number = 200
): { height: number; width: number } => {
  const ratio = grossCommonDevisor(image.width, image.height)
  const heightRatio = image.height / ratio
  const widthRatio = image.width / ratio

  const maxLengthFactor = image.width > image.height ? maxLength / widthRatio : maxLength / heightRatio

  return {
    height: heightRatio * maxLengthFactor,
    width: widthRatio * maxLengthFactor,
  }
}

export const loadImage = (src: string): Promise<HTMLImageElement> => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = reject
    img.src = src
  })
}
